/// <amd-module name="Feed/Core/Components/FeedMessageBar" />
import * as React from "react";
import { connect } from "react-redux";
import { DynamicModuleLoader } from "redux-dynamic-modules";

import { Link } from "VSSUI/Link";
import { MessageCard, MessageCardSeverity } from "VSSUI/MessageCard";

import { FeedMessage, MessageType } from "Feed/Common/Contracts/WebPage";
import { FeedHubActions } from "Feed/Core/Redux/FeedHub/FeedHubActions";
import { IFeedHubViewAwareState } from "Feed/Core/Redux/FeedHub/FeedHubContracts";
import { getFeedHubModules } from "Feed/Core/Redux/FeedHub/FeedHubModule";
import * as FeedHubSelectors from "Feed/Core/Redux/FeedHub/FeedHubSelectors";

const Actions = {
    deleteFeedMessage: FeedHubActions.deleteFeedMessage
};

export interface IFeedMessageBarProps {
    feedMessages: FeedMessage[];
    feedId?: string;
}

class UnconnectedFeedMessageBar extends React.Component<IFeedMessageBarProps & typeof Actions> {
    render() {
        if (this.props.feedMessages === []) {
            return;
        }
        return this.props.feedMessages.map((feedMessage, index) => {
            return (
                <MessageCard
                    key={feedMessage.id}
                    className={"feed-message " + feedMessage.id}
                    severity={
                        feedMessage.messageType === MessageType.Error
                            ? MessageCardSeverity.Error
                            : MessageCardSeverity.Info
                    }
                    onDismiss={() => {
                        this.props.deleteFeedMessage(this.props.feedId!, index);
                    }}
                >
                    {/* This space doesn't show up?*/}
                    {feedMessage.message + " "}
                    {feedMessage.linkText && (
                        <Link className="feed-message-link" href={feedMessage.linkUrl}>
                            {feedMessage.linkText}
                        </Link>
                    )}
                </MessageCard>
            );
        });
    }
}

function mapStateToProps(state: IFeedHubViewAwareState): IFeedMessageBarProps {
    return {
        feedMessages: FeedHubSelectors.getSelectedFeedMessages(state) || [],
        feedId: FeedHubSelectors.getSelectedFeedId(state)
    };
}

const ConnectedFeedMessageBar = connect(mapStateToProps, Actions)(UnconnectedFeedMessageBar);

export const FeedMessageBar = () => (
    <DynamicModuleLoader modules={getFeedHubModules()}>
        <ConnectedFeedMessageBar />
    </DynamicModuleLoader>
);
